import styled from '@emotion/styled';
import { translate, translateInComponent } from 'infras/i18n';
import translations from './i18n.json';
import { CustomerStoryListItem } from 'presentations/api/schema/contents';
import { customerStoryPath } from 'presentations/routes/path';
import {
  borderRadius,
  fontSize,
  fontWeight,
  spacing,
} from 'presentations/views/styles';
import { SyntheticEvent } from 'react';
import Image from 'presentations/views/components/atoms/Image';
import Link from 'presentations/views/components/atoms/Link';
import { white } from 'presentations/views/styles/color';

interface Props {
  customer: CustomerStoryListItem;
  onClick: (e: SyntheticEvent<HTMLAnchorElement>) => void;
}

export default function Component(props: Props) {
  const { customer } = props;
  const t = translateInComponent(translations);
  return (
    <CustomerListItemWrap key={customer.id}>
      <AdLogoImage
        src="logo/www_white_compact.svg"
        width={45}
        height={49}
        alt={translate('siteName')}
      />
      <CustomerListItem color={customer.customerColor}>
        <StyledLink
          href={customerStoryPath(customer.slug)}
          onClick={props.onClick}
        >
          <CustomerListItemImage>
            <CustomerImage image={customer.thumbnailImageUrl} />
          </CustomerListItemImage>
          <CustomerListItemInner>
            <CustomerListItemCompanyName>
              {customer.customerName}
            </CustomerListItemCompanyName>
            <CustomerListItemTitle>{customer.title}</CustomerListItemTitle>
          </CustomerListItemInner>
          <CustomerListItemButton>{t('more text')}</CustomerListItemButton>
        </StyledLink>
      </CustomerListItem>
    </CustomerListItemWrap>
  );
}

const CustomerListItemWrap = styled.div`
  border-radius: ${borderRadius(4)};
  overflow: hidden;
  position: relative;
  :last-child {
    margin-bottom: 0;
  }
`;

const AdLogoImage = styled(Image)`
  position: absolute;
  z-index: 1;
  top: 20px;
  left: 20px;
  width: 45px;
`;

const CustomerListItem = styled.div<{ color: string }>`
  background-color: ${(props) => props.color};
  overflow: hidden;
  height: 100%;
`;
const StyledLink = styled(Link)`
  display: block;
`;
const CustomerListItemImage = styled.div`
  position: relative;
  height: 230px;
`;
const CustomerListItemInner = styled.div`
  padding: ${spacing(12)} ${spacing(24)};
  color: ${white};
  font-weight: ${fontWeight('bold')};
  letter-spacing: 0.02em;
  line-height: 1.6;
`;
const CustomerListItemCompanyName = styled.div`
  text-align: center;
  font-size: ${fontSize(13)};
`;
const CustomerListItemTitle = styled.div`
  text-align: center;
  font-size: ${fontSize(16)};
`;

const CustomerImage = styled.div<{ image: string | null }>`
  background-image: url(${(props) => props.image});
  background-repeat: no-repeat;
  background-size: cover;
  width: 100%;
  height: 100%;
  background-position: center;
`;

const CustomerListItemButton = styled.div`
  border-radius: ${borderRadius(6)};
  border: 1px solid ${white};
  color: ${white};
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${spacing(8)} ${spacing(16)};
  margin: 0 ${spacing(16)} ${spacing(16)};
  font-weight: ${fontWeight('bold')};
  font-size: ${fontSize(16)};
`;
